/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExpatsInputs */

const cs_enum_expats = /** @type {(inputs: Enum_ExpatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expats.cz`)
};

const en_enum_expats = /** @type {(inputs: Enum_ExpatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expats.cz`)
};

/**
* | output |
* | --- |
* | "Expats.cz" |
*
* @param {Enum_ExpatsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_expats = /** @type {((inputs?: Enum_ExpatsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExpatsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_expats(inputs)
	return cs_enum_expats(inputs)
});